import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GridService } from "../shared/grid/grid.service";
import { ToastService } from "./toast.service";
import { Task } from "../models/task.model";
import { TaskAssignment } from "../models/taskAssignment.model";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { GroupLookup } from "../models/lookup.model";

@Injectable({
    providedIn: "root",
})
export class TaskService extends GridService<Task> {
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("Task", http);
    }

    getTaskAssignments(sensorAssignmentId: string) {
        return this.http
            .get<
                TaskAssignment[]
            >(this.getApiUrl(`TaskAssignment/GetTaskAssignments?sensorAssignmentId=${sensorAssignmentId}`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading task assignments",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getAllTasksForSeg(segId: any) {
        return this.http.get<Task[]>(
            this.getApiUrl(
                `${this.controllerName}/GetAllTasksForSeg?segId=` + segId,
            ),
        );
    }

    getGroupLookups(): Observable<GroupLookup[]> {
        return this.http
            .get<
                GroupLookup[]
            >(this.getApiUrl(`${this.controllerName}/GetGroupLookups`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading tasks",
                        true,
                    );
                    return of([]);
                }),
            );
    }
}
